/**
 * OVACS i18n bootstrap — Phase 1 of the dashboard refresh.
 *
 * Languages:
 *   - en (default, LTR)
 *   - ar (Arabic, RTL)
 *
 * Detection order:
 *   1. localStorage('ovacs.lang')  ← set explicitly via LanguageToggle
 *   2. navigator language          ← respect OS / browser preference
 *   3. fallback to 'en'
 *
 * The DirectionContext keeps `document.documentElement.lang` and `dir`
 * in sync with the i18next state. Page code only ever needs
 * `useTranslation()` to read strings.
 *
 * Strings are organized by namespace per the keys defined in en.json.
 * Components import `useTranslation()` without a namespace argument
 * (they all share the default namespace) — splitting by file can come
 * later if the file gets unwieldy.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import ar from './locales/ar.json'

const SUPPORTED = ['en', 'ar']
const STORAGE_KEY = 'ovacs.lang'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    returnEmptyString: false, // empty translation falls back instead of rendering nothing
    react: { useSuspense: false }, // load resources synchronously; no Suspense fallback needed
  })

export { SUPPORTED as SUPPORTED_LANGUAGES, STORAGE_KEY as LANG_STORAGE_KEY }
export default i18n
